import VideoUploader from "./VideoUploader";

const VideoUploaderModal = ({ isOpen, onClose, uploadEndpoint, refreshVideos }) => {
    if (!isOpen) return null;

    return (
        <div className="modalOverlay">
            <div className="modalContent">
                <h2>Upload Video Clips</h2>
                <VideoUploader uploadEndpoint={uploadEndpoint} refreshVideos={refreshVideos} />
                <button onClick={onClose}>Close</button>
            </div>
        </div>
    );
};

export default VideoUploaderModal;
